/* eslint-disable */
import React from "react";
import { useTranslation } from "react-i18next";

const ViewElectronicPrescriptionPopup = ({ selectedPrescription }) => {
  const { t } = useTranslation();

  if (!selectedPrescription) return null;

  return (
    <div
      className="offcanvas offcanvas-end"
      tabIndex="-1"
      id="viewElectronicPrescriptionOffCanvas"
      aria-labelledby="viewElectronicPrescriptionOffCanvasLabel"
      style={{ width: "600px" }}
    >
      <div className="offcanvas-header bg-light">
        <h5
          className="offcanvas-title fw-bold"
          id="viewElectronicPrescriptionOffCanvasLabel"
        >
          {t("Electronic Prescription Details")}
        </h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div className="offcanvas-body">
        <div className="details-view">
          {/* Patient Name */}
          <div className="form-group mb-4">
            <label className="d-block fs-sm fw-semibold mb-2 text-dark">
              Patient Name
            </label>
            <p className="form-control-plaintext border p-2 rounded bg-light">
              {selectedPrescription.patientName}
            </p>
          </div>

          {/* Medication */}
          <div className="form-group mb-4">
            <label className="d-block fs-sm fw-semibold mb-2 text-dark">
              Medication
            </label>
            <p className="form-control-plaintext border p-2 rounded bg-light">
              {selectedPrescription.medication}
            </p>
          </div>

          {/* Dosage */}
          <div className="form-group mb-4">
            <label className="d-block fs-sm fw-semibold mb-2 text-dark">
              Dosage
            </label>
            <p className="form-control-plaintext border p-2 rounded bg-light">
              {selectedPrescription.dosage}
            </p>
          </div>

          {/* Instructions */}
          <div className="form-group mb-4">
            <label className="d-block fs-sm fw-semibold mb-2 text-dark">
              Instructions
            </label>
            <p className="form-control-plaintext border p-2 rounded bg-light">
              {selectedPrescription.instructions || "No instructions provided"}
            </p>
          </div>

          {/* Prescription Date */}
          <div className="form-group mb-4">
            <label className="d-block fs-sm fw-semibold mb-2 text-dark">
              Prescription Date
            </label>
            <p className="form-control-plaintext border p-2 rounded bg-light">
              {selectedPrescription.prescriptionDate}
            </p>
          </div>

          {/* Status */}
          <div className="form-group mb-4">
            <label className="d-block fs-sm fw-semibold mb-2 text-dark">
              Status
            </label>
            <p className="form-control-plaintext border p-2 rounded bg-light">
              <span
                className={`badge ${
                  selectedPrescription.status === "Active"
                    ? "bg-success"
                    : "bg-secondary"
                }`}
              >
                {selectedPrescription.status}
              </span>
            </p>
          </div>
        </div>
      </div>
      <div className="offcanvas-footer bg-light p-3">
        <div className="d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-secondary"
            data-bs-dismiss="offcanvas"
          >
            {t("Close")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewElectronicPrescriptionPopup;
